import React, { useCallback, useMemo, useRef, useState } from 'react'
import cx from 'classnames'

import S from './styled'

import { EditIcon, CloseIcon } from '../icons'

export const TabsContent = ({ children }) => <component />

export const Tab = ({ component }) => <component />

const Tabs = ({
  children,
  onChange,
  selected,
  tabs,
  inverted,
  invertedControls,
  leftTabs,
  fullHeight,
  noMargin,
  onAdd,
  addItems,
  onEdit,
  onDelete,
}) => {

  const [menuOpened, setMenuOpened] = useState(false)

  const menuEl = useRef(null)

  const handleClickOutside = useMemo(() => {
    return event => {
      if (menuEl.current && !menuEl.current.contains(event.target)) {
        document.removeEventListener('mousedown', handleClickOutside)
        setMenuOpened(false)
      }
    }
  }, [])

  const hideMenu = useCallback(() => {
    document.removeEventListener('mousedown', handleClickOutside)
    setMenuOpened(false)
  }, [handleClickOutside])

  const showMenu = useCallback(() => {
    document.addEventListener('mousedown', handleClickOutside)
    setMenuOpened(true)
  }, [handleClickOutside])

  const handleAdd = useCallback((e,id) => {
    e.stopPropagation()
    onAdd(id)
    hideMenu()
  }, [hideMenu, onAdd])

  return (
    <S.Tabs className={cx({ leftTabs, noMargin })}>
      <S.TabsHeader className={cx({ inverted, leftTabs })}>
        {
          tabs.map((tab, tabIndex) => (
            <S.Tab
              key={tab.value}
              className={cx({
                active: tab.value === selected,
                inactive: tab.value !== selected,
                inverted,
                leftTabs,
                error: tab.value !== selected && tab.error,
                withEdit: onEdit && tab.value === selected,
              })}
              onClick={() => onChange && onChange(tab.value)}
            >
              <span>{tab.label}</span> {
                onEdit && tab.value === selected && (
                  <S.Icon onClick={onEdit}><EditIcon/></S.Icon>
                )
              }
              {
                onDelete && tab.value === selected && tabIndex !== 0 && (
                  <S.Delete onClick={() => onDelete(selected)}><CloseIcon/></S.Delete>
                )
              }
            </S.Tab>
          ))
        }
        {
          onAdd && <div style={{ position: 'relative' }}><S.Tab
            className={cx({
              inactive: true,
              inverted,
              leftTabs,
            })}
            onClick={addItems ? showMenu : onAdd}
          >
            + Add
          </S.Tab>
          {
            menuOpened && <S.Menu ref={menuEl}>
              {
                addItems && addItems.map(item => (
                  <S.MenuItem key={`menu-item-${item.id}`} onClick={e => handleAdd(e, item.id)}>
                    {item.description}
                  </S.MenuItem>
                ))
              }
            </S.Menu>
          }
          </div>
        }
      </S.TabsHeader>
      <S.TabsContent className={cx({
        inverted, leftTabs, invertedControls, fullHeight,
        firstSelected: tabs.findIndex(tab => tab.value === selected) === 0,
      })}>
        {
          children && typeof children === 'function' ? children(selected) : children
        }
      </S.TabsContent>
    </S.Tabs>
  )
}

export default Tabs
